module.exports = __webpack_public_path__ + "static/media/s3.a1a95bf0.svg";